/**
 * RampReady - Product Tabs
 * - Desktop: klikken op tab toont bijbehorende panel
 * - Mobile: klikken op accordion-heading expand/collapse panel
 * - Laadt Webwinkelkeur reviews in de reviews-tab via bestaande wwk-reviews.json
 */
(function () {
  function init(container) {
    const tabs = container.querySelectorAll('.product-tabs__tab');
    const panels = container.querySelectorAll('.product-tabs__panel');

    // Desktop: tab click → switch active
    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const key = tab.dataset.tab;
        tabs.forEach((t) => {
          const isActive = t === tab;
          t.classList.toggle('is-active', isActive);
          t.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });
        panels.forEach((panel) => {
          panel.classList.toggle('is-active', panel.dataset.panel === key);
        });

        if (key === 'reviews') loadReviews(container);
      });
    });

    // Mobile: accordion-toggle click → expand/collapse
    container.querySelectorAll('.product-tabs__accordion-toggle').forEach((toggle) => {
      toggle.addEventListener('click', () => {
        const expanded = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');

        // Bij open: reviews laden als dat de geopende panel is
        if (!expanded) {
          const panel = toggle.closest('.product-tabs__panel');
          if (panel && panel.dataset.panel === 'reviews') loadReviews(container);
        }
      });
    });

    // Initial: als de reviews-tab direct actief is, laad meteen
    const activePanel = container.querySelector('.product-tabs__panel.is-active');
    if (activePanel && activePanel.dataset.panel === 'reviews') {
      loadReviews(container);
    }

    // Mobile: default de eerste tab open zetten
    if (window.matchMedia('(max-width: 749px)').matches) {
      const firstToggle = container.querySelector('.product-tabs__accordion-toggle');
      if (firstToggle) firstToggle.setAttribute('aria-expanded', 'true');
    }
  }

  let reviewsLoaded = false;

  function loadReviews(container) {
    if (reviewsLoaded) return;
    const wrap = container.querySelector('[data-wwk-reviews]');
    if (!wrap) return;

    reviewsLoaded = true;

    // Gebruik bestaande wwk-reviews.json asset (site-brede reviews, zelf gebouwd)
    const assetUrl = wrap.dataset.assetUrl || (window.Shopify && Shopify.routes ? '' : '') || '/assets/wwk-reviews.json';

    // Liquid kan het juiste pad invullen - fallback naar relatief
    fetch(assetUrl)
      .catch(() => fetch('/cdn/shop/t/' + (document.documentElement.dataset.themeId || '1') + '/assets/wwk-reviews.json'))
      .then((r) => r.ok ? r.json() : null)
      .then((data) => {
        if (!data) {
          wrap.innerHTML = '<p class="product-tabs__reviews-loading">Reviews tijdelijk niet beschikbaar.</p>';
          return;
        }
        renderReviews(wrap, data);
      })
      .catch(() => {
        wrap.innerHTML = '<p class="product-tabs__reviews-loading">Reviews konden niet worden geladen.</p>';
      });
  }

  function renderReviews(wrap, data) {
    const avg = Number(data.average || 0).toFixed(1);
    const total = data.total || 0;
    const reviews = data.reviews || [];

    const starSvg = (filled) =>
      `<svg width="18" height="18" viewBox="0 0 24 24" fill="${filled ? 'currentColor' : 'none'}" stroke="currentColor" stroke-width="1.5"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>`;

    const summaryStars = Array.from({ length: 5 }, (_, i) => starSvg(i < Math.round(Number(data.average)))).join('');

    const months = ['jan', 'feb', 'mrt', 'apr', 'mei', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dec'];
    const formatDate = (ds) => {
      if (!ds) return '';
      const p = String(ds).split('-');
      return parseInt(p[2], 10) + ' ' + months[parseInt(p[1], 10) - 1] + ' ' + p[0];
    };

    const escape = (s) => String(s || '').replace(/[&<>"']/g, (c) => ({
      '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
    })[c]);

    const reviewHtml = reviews.map((r) => {
      const revStars = Array.from({ length: 5 }, (_, i) => starSvg(i < Number(r.rating))).join('');
      return `
        <div class="product-tabs__review">
          <div class="product-tabs__review-head">
            <span class="product-tabs__review-stars" style="color:#E63329;">${revStars}</span>
            <span class="product-tabs__review-date">${formatDate(r.date)}</span>
          </div>
          ${r.comment ? `<p class="product-tabs__review-body">"${escape(r.comment)}"</p>` : ''}
          <div class="product-tabs__review-foot">
            <span class="product-tabs__review-name">${escape(r.name || '')}</span>
            ${r.verified ? '<span class="product-tabs__review-verified">✓ Geverifieerd</span>' : ''}
          </div>
          ${r.reaction ? `
            <div class="product-tabs__review-reaction">
              <span class="product-tabs__review-reaction-label">Reactie van RampReady</span>
              <p class="product-tabs__review-reaction-text">${escape(r.reaction)}</p>
            </div>
          ` : ''}
        </div>
      `;
    }).join('');

    wrap.innerHTML = `
      <div class="product-tabs__review-summary">
        <span class="product-tabs__review-summary-stars" style="color:#E63329;">${summaryStars}</span>
        <span class="product-tabs__review-summary-score"><strong>${avg}</strong> / 5</span>
        <span class="product-tabs__review-summary-count">op basis van ${total} beoordelingen</span>
      </div>
      <div class="product-tabs__review-list">${reviewHtml}</div>
      <p class="product-tabs__small">
        <a href="https://www.webwinkelkeur.nl/webshop/Rampready_1221674" target="_blank" rel="noopener noreferrer">Bekijk alle reviews op Webwinkelkeur →</a>
      </p>
    `;
  }

  // Auto-init bij DOMContentLoaded
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-product-tabs]').forEach(init);
  });
})();
